import type { ReactNode } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-sans">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}